import React from "react";

const MarketScriptSkeleton = () => {
  return (
    <div className="structure-card-shadow py-4 px-5 rounded-[20px] max-w-[444px] animate-pulse">
      {/* Card header skeleton */}
      <div>
        {/* Title skeleton with generating text */}
        <p className="text-gray-500 text-sm font-medium mb-2">
          Generating marketing script...
        </p>
        <div className="flex items-center gap-2 mb-3">
          <div className="h-6 bg-gray-200 rounded w-[80%]"></div>
        </div>

        <div className="flex gap-x-5 items-center mb-2">
          {/* Script source badge skeleton */}
          <div className="flex items-center gap-x-1 border border-gray-200 px-[4.5px] py-[3px] rounded-lg">
            <div className="h-4 bg-gray-200 rounded w-32"></div>
            <div className="w-4 h-4 bg-gray-200 rounded"></div>
          </div>

          {/* Engagement metric skeleton */}
          <div className="bg-gray-100 rounded-[10px] py-1.5 px-2 inline-flex items-center">
            <div className="w-4 h-4 bg-gray-200 rounded mr-1"></div>
            <div className="h-4 bg-gray-200 rounded w-20"></div>
          </div>
        </div>

        {/* Duration skeleton */}
        <div className="h-4 bg-gray-200 rounded w-32 mt-2"></div>
      </div>

      {/* Script data type buttons skeleton */}
      <div className="my-5">
        <div className="flex justify-between gap-x-2">
          <div className="flex gap-x-2 flex-wrap">
            {[1, 2, 3].map((item) => (
              <div key={item} className="py-1 px-2 rounded-[4px] bg-gray-200">
                <div className="h-4 bg-gray-300 rounded w-16"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Content section skeleton */}
      <div className="bg-gray-50 border border-gray-200 py-3 px-[18px] rounded-lg mb-3">
        {/* Hook skeleton */}
        <div className="mb-2">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-semibold text-gray-600">Hook:</span>
            <span className="text-gray-500 text-sm">Generating hook...</span>
          </div>
          <div className="h-4 bg-gray-200 rounded w-4/5"></div>
        </div>

        {/* Main content skeleton */}
        <div className="mb-2">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-semibold text-gray-600">Main Content:</span>
            <span className="text-gray-500 text-sm">Generating content...</span>
          </div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>

        {/* Visual cues skeleton */}
        {/* <div className="mb-2">
          <div className="flex items-center gap-2 mb-2">
            <span className="font-semibold text-gray-600">Visual Cues:</span>
            <span className="text-gray-500 text-sm">Generating cues...</span>
          </div>
          <ul className="pl-4">
            {[1, 2, 3].map((cue) => (
              <li key={cue} className="mb-1">
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </li>
            ))}
          </ul>
        </div> */}
      </div>
    </div>
  );
};

export default MarketScriptSkeleton;
